import React from "react";

const QuizBanner = ({ bannerContent }) => {
  return (
    <div className="lc-banner lc-banner-information quiz-banner">
      <p
        dangerouslySetInnerHTML={{ __html: bannerContent }}
        className="banner-1 quiz-content"
      />
    </div>
  );
};

export default QuizBanner;
